import '~/sass/pages/tech-hybrid-1.scss';
import Vue from 'vue';
import Rx from 'rxjs/Rx';
import VueRx from 'vue-rx';

// import AArticle1pc from './article1-pc';
// import AArticle1mb from './article1-mb';

Vue.use(VueRx, Rx);

export default () => {
  const article1Vm = new Vue({
    el: '#article1',
    props: [],

    data() {
      return {
        clientWidth: document.body.clientWidth,
        showContent: false,
        animateContent: null,
        options: {
          offset: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          },
          threshold: 0.5,
        },
        once: false,
        playAnimate: false,
      };
    },

    mounted() {
      this.showContent = true;
      this.$subscribeTo(
        Rx.Observable.fromEvent(window, 'resize')
          .debounceTime(100)
          .distinctUntilChanged(),
        this.onResize,
      );
      // AArticle1pc();
      // AArticle1mb();
    },
    beforeDestroy() {
      this.showContent = false;
    },
    computed: {
      isMobile() {
        const { clientWidth } = this;
        return clientWidth <= 960;
      },
    },
    methods: {
      onResize() {
        this.clientWidth = document.body.clientWidth;
      },
      close() {
        this.gaev('btn_article_1_close');
        this.$emit('close');
      },
      onAnimateLoaded() {
        console.log('執行 onAnimateLoaded');
        const { $el } = this;
        this.animateContent = this.$el.querySelector('.animate_content');
        if (this.once) {
          this.once = false;
          this.playAnimate = false;
          return;
        }
        this.$subscribeTo(
          Rx.Observable.fromEvent($el, 'scroll')
            .map(() => this.onScroll())
            .debounceTime(100)
            .distinctUntilChanged(),
          this.inViewChanged,
        );
      },
      onScroll() {
        const { options, animateContent } = this;
        const {
          top,
          left,
          right,
          bottom,
          width,
          height,
        } = animateContent.getBoundingClientRect();
        const intersection = {
          top: bottom,
          left: right,
          right: window.innerWidth - left,
          bottom: window.innerHeight - top,
        };

        const threshold = {
          x: options.threshold * width,
          y: options.threshold * height,
        };

        return (
          intersection.top > options.offset.top + threshold.y
          && intersection.left > options.offset.left + threshold.x
          && intersection.right > options.offset.right + threshold.x
          && intersection.bottom > options.offset.bottom + threshold.y
        );
      },
      inViewChanged(bool) {
        // check inview once
        if (!bool) return;
        if (this.once) return;
        this.once = bool;

        // play animation
        this.playAnimate = true;
      },
      onMoreClick() {
        // this.gaev('btn_article_1_phv');
        window.open('https://www.toyota.com.tw/showroom/PRIUS_PHV/');
      },
    },
  });
  return article1Vm;
};
